import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportDatenbank extends GuiListGeneric {
    constructor() {
        super("Datenbank");
    }
}
